import { Paper, Title, Text, Stack } from '@mantine/core';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { useAliasesByOwner } from '../hooks/useAliasesByOwner';

const COLORS = ['#228be6', '#40c057', '#fab005', '#fa5252', '#be4bdb', '#15aabf', '#fd7e14', '#e64980'];

export const AliasesByOwnerChart = () => {
    const { data, loading } = useAliasesByOwner();

    if (loading) {
        return (
            <Paper p="lg" withBorder>
                <Text>Loading...</Text>
            </Paper>
        );
    }

    if (!data.length) {
        return (
            <Paper p="lg" withBorder>
                <Title order={4}>Aliases by Owner</Title>
                <Text c="dimmed">No data available</Text>
            </Paper>
        );
    }

    return (
        <Paper p="lg" withBorder>
            <Stack gap="md">
                <Title order={4}>Aliases by Owner</Title>
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${name}: ${((percent || 0) * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {data.map((_entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </Stack>
        </Paper>
    );
};
